import BaseModel from "./BaseModel";
import FileHandler from "@/composables/handlers/FileHandler";

/**
 * Material
 */
export default class Material extends BaseModel{
  constructor({
    id,
    name,
    description,
    source,
    mime_type,
    status,
    created_at,
    updated_at
  }) {
    super();

    this.id = id || null;
    this.name = name || null;
    this.description = description || null;
    this.source = source || null;
    this.mime_type = mime_type || null;
    this.status = status || null;
    this.created_at = created_at || null;
    this.updated_at = updated_at || null;
  }

  /**
   * Gets Material extension
   * @returns {String}
   */
  getExtension() {
    const extensions = FileHandler.getMimeTypes();
    return extensions[this.mime_type] != undefined ? extensions[this.mime_type] : '.txt';
  }
}
